// extracted by mini-css-extract-plugin
export default {"reservationButton":"_1ka_a","text":"_2lqTP","reservationButtonMobile":"_1AJz3"};